export default {
    created(){
        console.log("子路由打开=====", this.$route.path)
        this.$emit("childOpen", this.$route.path);
    },
    data() {
        return {
            
        }
    },
    methods: {
        
    }
};


// WEBPACK FOOTER //
// ./src/mixin/mixin.js